// This file was auto-generated by Fern from our API Definition.
export var InternalTemplateSource;
(function (InternalTemplateSource) {
    InternalTemplateSource.Kind = {
        Internal: "internal",
    };
})(InternalTemplateSource || (InternalTemplateSource = {}));
